import React from 'react';
import styled from 'styled-components';
import ds from 'designsystem';

const NotIcon = styled.svg`
    width: ${ds.get('metrics.s')};
    height: ${ds.get('metrics.s')};
    position: absolute;
    bottom: 0;
    right: 0;
    transform: scaleX(1.1) translateY(-50%);
    stroke: red;
    fill: none;
    z-index: 10;
`;

const CustomNotIcon = () => (
  <NotIcon viewBox="0 0 20 20">
    <polyline points="2,2 18,18" />
    <polyline points="2,18 18,2" />
  </NotIcon>
);

export default CustomNotIcon;



// WEBPACK FOOTER //
// ./src/blocks/Form/NotIcon.jsx